import Api, {getCancelToken, validToken} from 'services';

// ACTION TYPES
export const reportsHasErrored = () => ({type: '[REPORTS] HAS_ERRORED'});
export const reportsIsLoading = () => ({type: '[REPORTS] IS_LOADING'});
export const reportsFetchSuccess = data => ({type: '[REPORTS] FETCH_SUCCESS', data});
export const reportsCountFails = countFails => ({type: '[REPORTS] COUNT_FAILS', countFails});
export const reportsCountRepository = countRepository => ({type: '[REPORTS] COUNT_REPOSITORY', countRepository});


// ACTION CREATORS
export const reports_action_fetch = (params = {}) => dispatch => {

    dispatch(reportsIsLoading());
    Api.Reports.getReports(params)
        .then(data => dispatch(reportsFetchSuccess(data)))
        .catch(() => dispatch(reportsHasErrored()));
};

export const reports_action_download = (originalFile, originalName, bucket) => () => {

    Api.Reports.downloadReports(originalFile, originalName, bucket);
};

export const reports_action_count = () => dispatch => {

    dispatch(reportsIsLoading());
    Api.Reports.getReports({})
        .then(data => dispatch(reportsCountFails(data.totalElements)))
        .catch(() => dispatch(reportsHasErrored()));

    Api.Reports.getReports({error: false})
        .then(data => dispatch(reportsCountRepository(data.totalElements)))
        .catch(() => dispatch(reportsHasErrored()));
};

// ACTION CREATORS
export const reports_financial_action_fetch = (params = {}) => dispatch => {

    dispatch(reportsIsLoading());
    Api.Reports.getReportsFinancial(params)
        .then(data => dispatch(reportsFetchSuccess(data)))
        .catch(() => dispatch(reportsHasErrored()));
};

// ACTION CREATORS
export const reports_financial_mongo_action_fetch = (params = {}) => dispatch => {

    dispatch(reportsIsLoading());
    Api.Reports.getReportsFinancialMongoDb(params)
        .then(data => dispatch(reportsFetchSuccess(data)))
        .catch(() => dispatch(reportsHasErrored()));
};
